/**
 * ============================================================================
 * TESTIMONIAL SLIDER
 * ============================================================================
 * Responsive testimonial card slider with navigation controls
 * - Shows 3 cards on desktop, 2 on tablet, 1 on mobile
 * - Dynamically adjusts container height based on visible cards
 * - Supports infinite wrapping navigation
 */

(function() {
	// DOM element references
	const slider = document.getElementById('testimonialSlider');
	const sliderContainer = document.querySelector('.testimonial-slider-container');
	const prevBtn = document.getElementById('prevArrow');
	const nextBtn = document.getElementById('nextArrow');
	const cards = slider.querySelectorAll('.testimonial-card');

	// Slider state
	const totalCards = cards.length;
	let currentIndex = 0;
	let cardsVisible = 3;

	// Constants
	const CARD_GAP = 20; // Must match the gap value in CSS
	const RESIZE_DEBOUNCE_DELAY = 250; // Milliseconds to wait after resize
	const MOBILE_BREAKPOINT = 768;
	const TABLET_BREAKPOINT = 1024;

	/**
	 * Calculates how many testimonial cards should be visible based on screen width
	 * Breakpoints: mobile (<768px): 1 card, tablet (768-1023px): 2 cards, desktop (1024px+): 3 cards
	 */
	function updateCardsVisible() {
		const width = window.innerWidth;

		if (width < MOBILE_BREAKPOINT) {
			cardsVisible = 1;
		} else if (width < TABLET_BREAKPOINT) {
			cardsVisible = 2;
		} else {
			cardsVisible = 3;
		}
	}

	/**
	 * Updates the slider's transform to show cards starting at currentIndex
	 * Also triggers container height adjustment to prevent layout shifts
	 */
	function updateSlider() {
		const cardWidth = cards[0].offsetWidth;
		const offset = -(currentIndex * (cardWidth + CARD_GAP));

		slider.style.transform = `translateX(${offset}px)`;
		updateContainerHeight();
	}

	/**
	 * Adjusts the container height to match the tallest visible card
	 * This prevents content jumping when cards have different heights
	 */
	function updateContainerHeight() {
		const visibleCards = Array.from(cards).slice(currentIndex, currentIndex + cardsVisible);

		if (!visibleCards.length) {
			return;
		}

		// Reset all card heights to auto to get natural heights
		cards.forEach((card) => {
			card.style.height = 'auto';
		});

		// Find the tallest visible card
		const maxHeight = visibleCards.reduce((max, card) => {
			return Math.max(max, card.getBoundingClientRect().height);
		}, 0);

		// Set container to tallest card height
		sliderContainer.style.height = `${Math.ceil(maxHeight)}px`;
	}

	/**
	 * Navigate to previous testimonial card
	 * Wraps to the last position when at the beginning
	 */
	prevBtn.addEventListener('click', function() {
		if (currentIndex > 0) {
			currentIndex--;
		} else {
			// Wrap to last possible position
			currentIndex = totalCards - cardsVisible;
		}
		updateSlider();
	});

	/**
	 * Navigate to next testimonial card
	 * Wraps to the first position when at the end
	 */
	nextBtn.addEventListener('click', function() {
		if (currentIndex < totalCards - cardsVisible) {
			currentIndex++;
		} else {
			// Wrap back to beginning
			currentIndex = 0;
		}
		updateSlider();
	});

	/**
	 * Handle window resize with debouncing to prevent excessive calculations
	 * Resets to first slide if the number of visible cards changes
	 */
	let resizeTimer;
	window.addEventListener('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			const oldCardsVisible = cardsVisible;
			updateCardsVisible();

			if (oldCardsVisible !== cardsVisible) {
				// Reset to first slide when viewport changes (e.g., portrait to landscape)
				currentIndex = 0;
			}
			updateSlider();
		}, RESIZE_DEBOUNCE_DELAY);
	});

	// Initialize slider
	updateCardsVisible();
	updateSlider();
})();










/**
 * ============================================================================
 * SERIES SPOTLIGHT SLIDER
 * ============================================================================
 * Full-width slider for showcasing book series with navigation arrows
 * - Shows one full-width slide at a time
 * - Supports infinite wrapping navigation
 * - Adjusts slide positioning on window resize
 */

(function() {
	// DOM element references
	const spotlightSlider = document.getElementById('spotlightSlider');
	const spotlightPrevBtn = document.getElementById('spotlightPrevArrow');
	const spotlightNextBtn = document.getElementById('spotlightNextArrow');
	const spotlightSlides = spotlightSlider.querySelectorAll('.spotlight-slide');

	// Slider state
	const totalSlides = spotlightSlides.length;
	let currentSlideIndex = 0;

	// Constants
	const RESIZE_DEBOUNCE_DELAY = 250; // Milliseconds to wait after resize

	/**
	 * Updates the slider's transform to display the current slide
	 * Each slide takes up the full width of the container
	 */
	function updateSpotlightSlider() {
		const slideWidth = spotlightSlides[0].offsetWidth;
		const offset = -(currentSlideIndex * slideWidth);

		spotlightSlider.style.transform = `translateX(${offset}px)`;
	}

	/**
	 * Navigate to previous spotlight slide
	 * Wraps to the last slide when at the beginning
	 */
	spotlightPrevBtn.addEventListener('click', function() {
		if (currentSlideIndex > 0) {
			currentSlideIndex--;
		} else {
			// Wrap to last slide
			currentSlideIndex = totalSlides - 1;
		}
		updateSpotlightSlider();
	});

	/**
	 * Navigate to next spotlight slide
	 * Wraps to the first slide when at the end
	 */
	spotlightNextBtn.addEventListener('click', function() {
		if (currentSlideIndex < totalSlides - 1) {
			currentSlideIndex++;
		} else {
			// Wrap back to first slide
			currentSlideIndex = 0;
		}
		updateSpotlightSlider();
	});

	/**
	 * Handle window resize with debouncing
	 * Recalculates slide width to ensure proper positioning
	 */
	let spotlightResizeTimer;
	window.addEventListener('resize', function() {
		clearTimeout(spotlightResizeTimer);
		spotlightResizeTimer = setTimeout(function() {
			updateSpotlightSlider();
		}, RESIZE_DEBOUNCE_DELAY);
	});

	// Initialize slider
	updateSpotlightSlider();
})();










/**
 * ============================================================================
 * LOGO SLIDER - INFINITE SCROLL
 * ============================================================================
 * Automatically scrolling logo carousel with dynamic width calculation
 * - Displays partner/client logos in a continuous loop
 * - Logos are duplicated in the DOM to create seamless infinite scroll effect
 * - Calculates exact scroll distance based on actual logo widths + gaps
 * - Waits for all images to load before initializing to prevent layout jumps
 * - Uses CSS custom property (--scroll-distance) to control animation
 */

(function() {
	// DOM element references
	const logoTrack = document.querySelector('.logo-slider-track');
	if (!logoTrack) return; // Exit if logo slider doesn't exist on this page

	// State tracking
	let isCalculated = false;

	// Constants
	const DEFAULT_GAP = 100; // Fallback gap value if CSS gap can't be computed (in pixels)
	const LAYOUT_STABILITY_DELAY = 100; // Delay after images load to ensure stable layout

	/**
	 * Calculates the exact distance the logo track needs to scroll for seamless looping
	 * The logos are duplicated in the HTML (Part 1 + Part 2), so we calculate the width
	 * of the first half and use that as the scroll distance. When the animation completes,
	 * it seamlessly loops because Part 2 is identical to Part 1.
	 */
	function calculateScrollDistance() {
		const allLogos = logoTrack.querySelectorAll('img');
		const totalLogos = allLogos.length;

		if (totalLogos === 0) return;

		// Logos are duplicated, so we only need to measure the first half
		const uniqueLogoCount = totalLogos / 2;

		// Get the gap value from CSS (should be 100px, but we dynamically read it)
		const computedStyle = window.getComputedStyle(logoTrack);
		const gap = parseFloat(computedStyle.gap) || DEFAULT_GAP;

		// Calculate total width of the first set of logos (including gaps between them)
		let totalWidth = 0;
		for (let i = 0; i < uniqueLogoCount; i++) {
			totalWidth += allLogos[i].offsetWidth;

			// Add gap after each logo except the last one
			if (i < uniqueLogoCount - 1) {
				totalWidth += gap;
			}
		}

		// Update CSS custom property to control the animation distance
		if (totalWidth > 0) {
			logoTrack.style.setProperty('--scroll-distance', `-${totalWidth}px`);
			isCalculated = true;
		}
	}

	/**
	 * Initializes the logo slider by waiting for all images to load
	 * This prevents layout shifts that would occur if we calculated widths
	 * before images had their natural dimensions
	 */
	function initSlider() {
		const allLogos = logoTrack.querySelectorAll('img');
		let loadedCount = 0;
		const totalLogos = allLogos.length;

		if (totalLogos === 0) return;

		/**
		 * Callback fired each time an image loads or errors
		 * Once all images are loaded, calculate the scroll distance
		 */
		function checkAllLoaded() {
			loadedCount++;

			if (loadedCount === totalLogos && !isCalculated) {
				// Small delay to ensure browser has finished layout calculations
				setTimeout(calculateScrollDistance, LAYOUT_STABILITY_DELAY);
			}
		}

		// Check each logo image
		allLogos.forEach(img => {
			if (img.complete) {
				// Image already loaded (cached)
				checkAllLoaded();
			} else {
				// Wait for image to load or fail
				img.addEventListener('load', checkAllLoaded);
				img.addEventListener('error', checkAllLoaded); // Handle errors gracefully
			}
		});
	}

	// Initialize based on document ready state
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSlider);
	} else {
		// DOM already loaded
		initSlider();
	}

	// Fallback: ensure calculation runs on window load event
	// This catches edge cases where images load after DOMContentLoaded
	window.addEventListener('load', function() {
		if (!isCalculated) {
			calculateScrollDistance();
		}
	});
})();










/**
 * ============================================================================
 * NEWSLETTER SIGNUP FORM - HUBSPOT INTEGRATION
 * ============================================================================
 * Handles newsletter subscription form submission to HubSpot CRM
 * - Submits email address to HubSpot Forms API
 * - Prevents double submissions and accidental page navigation during submit
 * - Shows success message and hides form on successful subscription
 * - Handles errors gracefully and allows retry on failure
 *
 * HubSpot Configuration:
 * - Portal ID: 242488439
 * - Form GUID: 88489357-437f-4cc5-a56c-958f0ec85aac
 */

(function() {
	document.addEventListener('DOMContentLoaded', function() {
		// DOM element references
		const form = document.querySelector('.newsletter-form');
		const successMessage = document.querySelector('.form-success-message');
		const newsletterFooter = document.querySelector('.newsletter-footer');

		if (!form) return; // Exit if newsletter form doesn't exist on this page

		// Form elements
		const submitButton = form.querySelector('.newsletter-submit');
		const originalButtonText = submitButton ? submitButton.textContent : 'Get 10% Off';

		// State tracking
		let isSubmitting = false;
		let beforeUnloadHandler = null;

		// HubSpot API configuration
		const HUBSPOT_PORTAL_ID = '242488439';
		const HUBSPOT_FORM_GUID = '88489357-437f-4cc5-a56c-958f0ec85aac';
		const HUBSPOT_API_URL = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_GUID}`;

		/**
		 * Handles form submission
		 * - Prevents default form behavior and double submissions
		 * - Updates UI to show submitting state
		 * - Sends data to HubSpot API
		 * - Shows success or error state based on response
		 */
		form.addEventListener('submit', function(e) {
			e.preventDefault();

			// Prevent double submission while request is in flight
			if (isSubmitting) {
				return;
			}

			isSubmitting = true;

			// Update button to show submitting state
			if (submitButton) {
				submitButton.disabled = true;
				submitButton.textContent = 'Submitting...';
			}

			// Collect form data
			const formData = new FormData(form);

			// Format data according to HubSpot API requirements
			const hubspotData = {
				'fields': [
					{ 'name': 'email', 'value': formData.get('email') || '' }
				]
			};

			// Prevent user from accidentally leaving during submission
			beforeUnloadHandler = function(e) {
				e.preventDefault();
				e.returnValue = 'Your form is being submitted. Are you sure you want to leave?';
				return e.returnValue;
			};
			window.addEventListener('beforeunload', beforeUnloadHandler);

			// Submit to HubSpot Forms API
			fetch(HUBSPOT_API_URL, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(hubspotData)
			})
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then(data => {
				// Check for errors in the response payload
				if (data.errors || data.status === 'error') {
					console.error('HubSpot returned error in response:', data);
					throw new Error('HubSpot submission failed');
				}

				// Identify user in Rudderstack
				const email = hubspotData.fields[0].value;
				if (email && window.rudderanalytics && typeof rudderanalytics.identify === 'function') {
					rudderanalytics.identify(email);
				}

				// Remove navigation warning on success
				if (beforeUnloadHandler) {
					window.removeEventListener('beforeunload', beforeUnloadHandler);
				}

				// Success! Update UI to show success state
				isSubmitting = false;

				// Hide the form and footer
				form.classList.add('hidden');
				if (newsletterFooter) {
					newsletterFooter.classList.add('hidden');
				}

				// Show success message and scroll it into view
				successMessage.classList.add('show');
				successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
			})
			.catch(error => {
				// Handle submission errors
				console.error('HubSpot submission error:', error);
				if (window.Bugsnag && typeof Bugsnag.notify === 'function') { Bugsnag.notify(error); }

				// Remove navigation warning on error
				if (beforeUnloadHandler) {
					window.removeEventListener('beforeunload', beforeUnloadHandler);
				}

				// Reset form to allow retry
				isSubmitting = false;

				// Re-enable submit button and restore original text
				if (submitButton) {
					submitButton.disabled = false;
					submitButton.textContent = originalButtonText;
				}

			});
		});
	});
})();










/**
 * ============================================================================
 * HERO BOTTOM TEXT RESPONSIVE LAYOUT
 * ============================================================================
 * Changes hero bottom text layout based on screen size
 * - Shows each point on a new line on mobile (400px and below)
 * - Shows inline with bullet points on larger screens
 */

(function() {
	// DOM element reference
	const heroBottomText = document.querySelector('.hero-bottom-text p');

	if (!heroBottomText) return; // Exit if hero bottom text doesn't exist on this page

	// Store the original HTML content
	const ORIGINAL_HTML = heroBottomText.innerHTML;
	const MOBILE_BREAKPOINT = 700;

	/**
	 * Updates the hero bottom text layout based on current screen width
	 * Replaces bullet point separators with line breaks on mobile
	 */
	function updateHeroBottomText() {
		const width = window.innerWidth;

		if (width <= MOBILE_BREAKPOINT) {
			// Replace bullet points and surrounding spaces with line breaks
			const mobileHTML = ORIGINAL_HTML
				.replace(/\s*&nbsp;\s*•\s*&nbsp;\s*/g, '<br>')
				.replace(/\s*•\s*/g, '<br>');
			heroBottomText.innerHTML = mobileHTML;
		} else {
			// Restore original content with bullet points
			heroBottomText.innerHTML = ORIGINAL_HTML;
		}
	}

	// Update layout on page load
	updateHeroBottomText();

	// Update layout when window is resized
	window.addEventListener('resize', updateHeroBottomText);
})();









